import {environment as localEnvironment} from './environment.local';

// Extend the Window interface to include config
declare global {
  interface Window {
    config: any;
    APP_ENV: any;
  }
}

const config = window["APP_ENV"]
export const environment = Object.assign(localEnvironment, config)